export default {
    vehicleChangeID: "",
    policyUserId: "",
    policyNumber: "",
    effectiveDate: "",
    expirationDate: "",
    firstName: "",
    middleInitial: "",
    lastName: "",
    emailAddress: "",
    policyState: "",
    vehicles: {
        vehiclesOnPolicy: {
            pendingNewVehicles: [],
            pendingRemovedVehicles: [],
            storedVehicles: [],
            newVehicles: []
        },
        keptOvernightResponse: "",
        keptOvernightAddress: "",
        keptOvernightCity: "",
        keptOvernightState: "",
        keptOvernightZip: "",
        keptOvernightLocation: ""
    },
    driversHHMs: {
        dateOfChange: "",
        drivers: {
            pendingNewDrivers: [],
            pendingRemovedDrivers: [],
            storedDrivers: [],
            newDrivers: []
        },
        householdMembers: {
            pendingNewMembers: [],
            pendingRemovedMembers: [],
            storedMembers: [],
            newMembers: []
        },
        pendingAddedDrivers: [],
        pendingAddedHhms: [],
        pendingRemovedDrivers: [],
        pendingRemovedHhms: []
    },
    driverAssignment: {
        drivers: {
            fullName: "",
            DOB: "",
            currRel: "",
            gender: "",
            initialType: "",
            licenseNum: "",
            mStatus: "",
            drivesVehicle: "",
            vehicleID: "",
            vehicleUse: "",
            vehicleUseExplanation: "",
            annualMileage: ""
        },
    },
    summary: {
        phoneNumber: ""
    },
    confirmation: {
        date: ""
    }
}